import { createSlice } from "@reduxjs/toolkit";
import { authApi } from "./auth.api";
import { apiMutaion } from "../ApiMutaion";

export const USER_TYPES = Object.freeze({
  SCHOOL: "school",
  STUDENT: "student",
  TEACHER: "teacher"
});

const initialState = {
  user: null,
  userType: null,
  tokens: null,
  mdm: null,
  selectedEventsDetails: null,
  registrationPayload: null,
  paymentsDetails: null,
  deviceAndLocation: null,
  createdEventMappings: null
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLogout(state) {
      state.user = initialState.user;
      state.userType = initialState.userType;
      state.tokens = initialState.tokens;
      state.registrationPayload = initialState.registrationPayload;
      state.selectedEventsDetails = initialState.selectedEventsDetails;
      state.paymentsDetails = initialState.paymentsDetails;
      state.deviceAndLocation = initialState.deviceAndLocation;
      state.createdEventMappings = initialState.createdEventMappings;
    },
    setUserActive(state) {
      state.user.is_active = true;
    },
    setSelectedEventsDetails(state, action) {
      state.selectedEventsDetails = action.payload;
    },
    setPaymentDetails(state, action) {
      state.paymentsDetails = action.payload;
    },
    clearSelectedEventsDetails(state) {
      state.selectedEventsDetails = null;
    },
    setRegistrationPayload(state, action) {
      state.registrationPayload = action.payload;
    },
    setDeviceAndLocationPayload(state, action) {
      state.deviceAndLocation = action.payload;
    },

    clearCreatedEventMappings: (state) => {
      state.createdEventMappings = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(authApi.endpoints.signupSchoolFinish.matchFulfilled, setPlanInfo)
      .addMatcher(authApi.endpoints.signupSchool.matchFulfilled, setSchoolInfo)
      .addMatcher(authApi.endpoints.loginSchool.matchFulfilled, setSchoolInfo)
      .addMatcher(authApi.endpoints.studentLoginOTP.matchFulfilled, setStudentInfo)
      .addMatcher(authApi.endpoints.studentSignUp.matchFulfilled, setStudentInfo)
      .addMatcher(authApi.endpoints.studentSignUpDeeplink.matchFulfilled, setStudentInfo)
      .addMatcher(authApi.endpoints.studentLoginPassword.matchFulfilled, setStudentInfo)
      .addMatcher(authApi.endpoints.studentLoginAdmissionID.matchFulfilled, setStudentInfo)
      .addMatcher(apiMutaion.endpoints.updateExamID.matchFulfilled, (state, { payload, meta }) => {
        if (state.selectedEventsDetails && payload?.exam_id) {
          state.selectedEventsDetails = {
            ...state.selectedEventsDetails,
            exam_id: payload.exam_id
          };
        }
      });
  }
});

export const {
  userLogout,
  setUserActive,
  setSelectedEventsDetails,
  clearSelectedEventsDetails,
  setRegistrationPayload,
  setPaymentDetails,
  setDeviceAndLocationPayload,
  clearCreatedEventMappings
} = authSlice.actions;

export default authSlice.reducer;

const setPlanInfo = (state, { payload }) => {
  if (payload) {
    state.planInfo = payload;
  }
};

const setSchoolInfo = (state, { payload }) => {
  if (payload) {
    state.userType = USER_TYPES.SCHOOL;
    state.user = payload.user;
    state.tokens = payload.token;
  }
};

const setStudentInfo = (state, { payload }) => {
  const responseData = payload?.data || payload?.details?.data;
  if (payload && responseData) {
    state.userType = USER_TYPES.STUDENT;

    state.user = {
      account_type: responseData.account_type,
      admission_id: responseData.admission_id,
      branch_id: responseData.branch_id,
      crn_id: responseData.crn_id,
      email: responseData.email,
      exam: responseData.exam,
      exam_id: responseData.exam_id,
      first_name: responseData.first_name,
      grade_id: responseData.grade_id,
      hall_ticket_id: responseData.hall_ticket_id,
      is_active: responseData.is_active,
      isd_code: responseData.isd_code,
      last_name: responseData.last_name,
      phone: responseData.phone,
      registration_source: responseData.registration_source,
      school_id: responseData.school_id,
      uam_id: responseData.uam_id,
      udise_code: responseData.udise_code,
      whatsapp_consent: responseData.whatsapp_consent
    };

    state.tokens = {
      access_token: `Bearer ${responseData.access_token}`,
      refresh_token: responseData.refresh_token
    };

    state.mdm = {
      branch_id: responseData.branch_id,
      grade_id: responseData.grade_id,
      role_ids: responseData.role_ids
    };

    state.createdEventMappings =
      payload?.created_event_mappings || payload?.details?.created_event_mappings || null;

    const userCrn_id = state.user ? state.user.crn_id : "";
    if (userCrn_id && userCrn_id.length > 4) {
      const gaEventObj = {
        event: "userData_InMobius",
        user_id: userCrn_id
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(gaEventObj);
    }
  }
};
